import { render, staticRenderFns } from "./HowDoWeDoThat.vue?vue&type=template&id=473bd258&scoped=true&"
import script from "./HowDoWeDoThat.vue?vue&type=script&lang=js&"
export * from "./HowDoWeDoThat.vue?vue&type=script&lang=js&"
import style0 from "./HowDoWeDoThat.vue?vue&type=style&index=0&id=473bd258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473bd258",
  null
  
)

export default component.exports